import React, { Component } from 'react';
import type { Store } from 'redux';
import equal from 'lodash/isEqual';
import pick from 'lodash/pick';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import type { Callbacks, Context } from './model/index.tsx';
import rootEpic from './ops/index.tsx';
import { setAppProps } from './state/actions/app-props.tsx';
import { deleteComponentRequest } from './state/actions/delete.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	OnFail,
	OnSuccessful,
	OnDialogDisplay,
	OnIssueCountFetched,
	OnDialogCancel,
} from './model';

export type Props = Callbacks & Context;

const pickContextFromProps = (props: Props): Context =>
	pick(props, [
		'id',
		'name',
		'baseUrl',
		'projectKey',
		'locale',
		'analyticsData',
		'relatedIssueCount',
		'relatedIssueUrl',
	]);

const pickCallbackFromProps = (props: Props): Callbacks =>
	pick(props, [
		'onIssueCountFetched',
		'onSuccessful',
		'onFail',
		'onDialogDisplay',
		'onDialogCancel',
	]);

// eslint-disable-next-line jira/react/no-class-components
export default class DeleteVersionSubApp extends Component<Props> {
	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic, this.props.name);
		this.setAppProps(this.props);
	}

	componentDidMount() {
		this.store.dispatch(deleteComponentRequest());
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		if (!equal(this.props, nextProps)) {
			this.setAppProps(nextProps);
		}
	}

	setAppProps(props: Props) {
		this.store.dispatch(
			setAppProps({
				context: pickContextFromProps(props),
				callbacks: pickCallbackFromProps(props),
			}),
		);
	}

	store: Store<State>;

	render() {
		return (
			<AppBase store={this.store}>
				<ReportErrors
					id="unhandled"
					packageName="jiraProjectDirectoriesComponents"
					teamName="morphinecake"
					sendToPrivacyUnsafeSplunk
				>
					<View />
				</ReportErrors>
			</AppBase>
		);
	}
}
